import React from "react";
import { Button, Icon, Popup } from "semantic-ui-react";

const defaultStyle = { display: "flex", flexDirection: "row", gap: 8 };

function ScheduleViewContactsTableExtraButtons({ emailCount, entityCount }) {
  if (!emailCount && !entityCount) {
    return null;
  }

  const contactsButton = (
    <Button className="standard no-click" style={defaultStyle} size="tiny" icon>
      <Icon name="mail" />
      <span>{emailCount}</span>
    </Button>
  );

  const entitiesButton = (
    <Button className="standard no-click" style={defaultStyle} size="tiny" icon>
      <Icon name="building" />
      <span>{entityCount}</span>
    </Button>
  );

  return (
    <div style={defaultStyle}>
      <Popup trigger={contactsButton} content="Number of e-mails to be sent" />
      <Popup
        trigger={entitiesButton}
        content="Number of entities to be sent to"
      />
    </div>
  );
}

export default ScheduleViewContactsTableExtraButtons;
